import { Dictionary } from '@/dictionary/Dictionary'
import i18n from '@/i18n'

const itemNameModeDict: Array<Dictionary> = []

for (const code of ['hide', 'simple', 'full', 'custom']) {
    itemNameModeDict.push({ code: code, name: i18n.t(`dictionary.itemNameMode.${code}`).toString() })
}

export { itemNameModeDict }
